import React from "react";
import img_1 from "../assets/static/img/x1.jpg";
import img_2 from "../assets/static/img/x2.jpg";
import img_3 from "../assets/static/img/x3.jpg";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

class blogsWithCollections extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t } = this.props;
    return (
      <>
        <div className="container" >
        <div className="category-container" >
            <div
              className="category-card pointer"
              style={{ color: "white", fontSize: '1.3rem', position: 'relative' }}
              onClick={() => this.props.history.push("searcht?offset=0&sort-by=isNew")}
            >
              <img src={img_1} alt="img_1"/>
              <p style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>{t("new_collections.text")}</p>
            </div>
            <div
              className="category-card pointer"
              style={{ color: "white", fontSize: '1.3rem', position: 'relative' }}
              onClick={() => this.props.history.push("searcht?offset=0&sort-by=isTrend")}

            >
              <img src={img_2} alt="img_2"/>
              <p style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>{t("top_collections.text")}</p>
            </div>
            <div
              className="category-card pointer"
              style={{  color: "white", fontSize: '1.3rem', position: 'relative' }}
              onClick={() => this.props.history.push("searcht?offset=0&sort-by=discount")}

            >
              <img src={img_3} alt="img_3"/>
              <p style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>{t("discount.text")}</p>
            </div>
          </div>
          <h1 style={{color: "white", paddingTop: "70px"}}>{t("Blog.text")}</h1>
          {/* <div className="d-flex justify-content-between" style={{ gap: "2rem" }}>
            <div
              className="col"
              style={{ backgroundImage: `url(${img_1})`, height: "470px", color: "white", fontSize: '1.8rem', lineHeight: '2.5rem', padding: '1.5rem', fontWeight: '400' }}
            >
              Yotoqxonaga gilam tanlashdagi xatolar
            </div>
            <div
              className="col"
              style={{ backgroundImage: `url(${img_2})`, height: "470px", color: "white", fontSize: '1.8rem', lineHeight: '2.5rem', padding: '1.5rem', fontWeight: '400' }}
            >
              Bolalar xonasiga qanday gilam tanlash kerak?
            </div>
            <div
              className="col"
              style={{ backgroundImage: `url(${img_3})`, height: "470px", color: "white", fontSize: '1.8rem', lineHeight: '2.5rem', padding: '1.5rem', fontWeight: '400' }}
            >
              Gilamni qanday qilib uzoq saqlab qolish mumkin?
            </div>
          </div> */}
          
        </div>
      </>
    );
  }
}
export default withRouter(withTranslation()(blogsWithCollections));
